"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_redux_1 = require("react-redux");

var scenario_selectors_1 = require("../../redux/scenario/scenario.selectors");

var action_preview_component_1 = __importDefault(require("./action-preview.component"));

var scenario_utils_1 = require("../../redux/scenario/scenario.utils");

var ActionPreviewContainer = function ActionPreviewContainer(_ref) {
  var scale = _ref.scale;
  var action = react_redux_1.useSelector(scenario_selectors_1.selectPreviewAction);
  var selectChildNode = action && action.actionId ? scenario_selectors_1.getSelectParsedNode(action.actionId) : function () {
    return undefined;
  };
  var childNode = react_redux_1.useSelector(selectChildNode); // actionUrl を parse (urlVariable.key ==> urlVariable.value)

  var urlKey = action && action.actionUrl ? scenario_utils_1.extractKey(action.actionUrl) : undefined;
  var selectUrl = urlKey ? scenario_selectors_1.getSelectUrlByKey(urlKey) : function () {
    return undefined;
  };
  var url = react_redux_1.useSelector(selectUrl);
  if (!action) return null;
  return react_1.default.createElement(action_preview_component_1.default, {
    childNode: childNode,
    actionUrl: url,
    scale: scale
  });
};

exports.default = ActionPreviewContainer;